<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_ii"></a>ALSO BY ELIZABETH ADLER</p>
<p class="para"> </p>
<p class="center-para"><em>One of Those Malibu Nights</em></p>
<p class="center-para"><em>Meet Me in Venice</em></p>
<p class="center-para"><em>Sailing to Capri</em></p>
<p class="center-para"><em>The House in Amalfi</em></p>
<p class="center-para"><em>Invitation to Provence</em></p>
<p class="center-para"><em>The Hotel Riviera</em></p>
<p class="center-para"><em>Summer in Tuscany</em></p>
<p class="center-para"><em>The Last Time I Saw Paris</em></p>
<p class="center-para"><em>In a Heartbeat</em></p>
<p class="center-para"><em>Sooner or Later</em></p>
<p class="center-para"><em>All or Nothing</em></p>
<p class="center-para"><em>Now or Never</em></p>
<p class="center-para"><em>Fleeting Images</em></p>
<p class="center-para"><em>Indiscretions</em></p>
<p class="center-para"><em>The Heiress</em></p>
<p class="center-para"><em>The Secret of Villa Mimosa</em></p>
<p class="center-para"><em>Legacy of Secrets</em></p>
<p class="center-para"><em>Fortune Is a Woman</em></p>
<p class="center-para"><em>The Property of a Lady</em></p>
<p class="center-para"><em>The Rich Shall Inherit</em></p>
<p class="center-para"><em>Peach</em></p>
<p class="center-para"><em>Léonie</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?76268ca2